
    import './styles.scoped.css';
    export default {
  "content-wrapper": "awsui_content-wrapper_zycdx_1u7dy_97",
  "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_1u7dy_101",
  "content-type-dashboard": "awsui_content-type-dashboard_zycdx_1u7dy_106"
};
  